import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { HttpErrorResponse } from '@angular/common/http'
import { GenericValidatorService } from 'src/app/services/validators/generic-validator.service'
import { ControlSelectOptions } from 'src/app/models/control-select-options'
import { ContentService } from 'src/app/services/content/content.service'
import { ModalDefaultComponent } from '../modals/modal-default/modal-default.component'

@Component({
	selector: 'app-b2b-form',
	templateUrl: './b2b-form.component.html',
	styleUrls: ['./b2b-form.component.scss'],
})
export class B2bFormComponent implements OnInit, AfterViewInit {
	form: FormGroup = new FormGroup({})
	submitting = false

	modalSuccessTitle = ''
	modalSuccessText = ''
	modalErrorTitle = ''
	modalErrorText = ''
	modalButtonLabel = 'Confirmar'

	employeesOptions: ControlSelectOptions[] = [
		{ value: '100', label: 'Até 100' },
		{ value: '100-300', label: '100 a 300' },
		{ value: '300-500', label: '300 a 500' },
		{ value: '500+', label: 'Mais de 500' },
	]

	lang = 'pt'

	constructor(
		private formBuilder: FormBuilder,
		private elementRef: ElementRef,
		private content: ContentService,
		private modal: NgbModal,
		private route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.lang = this.route.snapshot.params.lang || 'pt'
		this.content.getPage('dictionary/?limit=9999&', this.lang, {
			fnSuccess: (data: any) => {
				data.items.forEach((item: any) => {
					if (item.key === 'modalSuccessTitle') {
						this.modalSuccessTitle = item.value
					} else if (item.key === 'modalSuccessText') {
						this.modalSuccessText = item.value
					} else if (item.key === 'modalErrorTitle') {
						this.modalErrorTitle = item.value
					} else if (item.key === 'modalErrorText') {
						this.modalErrorText = item.value
					}
				})
			},
			fnError: (error: any) => console.warn(error),
		})

		this.form = this.formBuilder.group({
			name: [null, [Validators.required, GenericValidatorService.completeName]],
			company: [null, [Validators.required]],
			city: [null, [Validators.required]],
			state: [null, [Validators.required]],
			email: [null, [Validators.required, Validators.email]],
			phone: [
				null,
				[
					Validators.required,
					GenericValidatorService.numbersOnly,
					GenericValidatorService.validatePhone,
				],
			],
			employees_number: ['', [Validators.required]],
			message: [null, [Validators.required]],
		})
	}

	ngAfterViewInit(): void {
		const select = this.elementRef.nativeElement.querySelector(
			'select[name="employees_number"]'
		) as HTMLSelectElement | null
		if (!select) {
			return
		}

		let attempts = 0
		const ensurePlaceholderSelected = () => {
			if (select.selectedIndex === -1) {
				select.selectedIndex = 0
			}
			attempts++
			if (attempts < 10) {
				setTimeout(ensurePlaceholderSelected, 300)
			}
		}
		setTimeout(ensurePlaceholderSelected)
	}

	onSubmit(): void {
		if (this.form.invalid || this.submitting) {
			this.form.markAllAsTouched()
			return
		}
		const self = this
		const { name, company, city, state, email, phone, employees_number, message } = this.form.value

		this.submitting = true
		this.content.sendForm('b2b_savings_form', {
			payload: {
				full_name: name,
				company_name: company,
				city,
				state,
				email,
				phone: this.formatPhone(phone),
				employees_number,
				message,
			},
			fnSuccess() {
				self.submitting = false
				self.form.reset()
				self.openModal(self.modalSuccessTitle, self.modalSuccessText, self.modalButtonLabel)
				window.dataLayer.push({
					event: 'sendB2B',
					eventCategory: 'lead',
					eventAction: 'send',
					eventLabel: '',
				})

			},
			fnError(error: HttpErrorResponse) {
				self.submitting = false
				console.warn(error)
				self.openModal(self.modalErrorTitle, self.modalErrorText, self.modalButtonLabel)
			},
		})
	}

	private formatPhone(digits: string): string {
		if (!digits) {
			return digits
		}
		if (digits.length === 11) {
			return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
		}
		if (digits.length === 10) {
			return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
		}
		return digits
	}

	openModal(title: string = '', description: string = '', buttonLabel: string = 'Confirmar'): void {
		const modalRef = this.modal.open(ModalDefaultComponent)
		modalRef.componentInstance.title = title || 'Opa!'
		modalRef.componentInstance.desc =
			description || 'Algo não aconteceu como deveria, por favor tente novamente.'
		modalRef.componentInstance.labelButtonConfirmation = buttonLabel || 'Confirmar'
	}
}
